// 尺寸454*320
import React, { useRef, useEffect, useState } from 'react'
import { RollbackOutlined, ClearOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { Button, Row, Col, Input, ConfigProvider } from 'antd'
import { Card as MobileCard, Grid as MobileGrid } from 'antd-mobile'
import { formatMessageNew } from '@/utils/common'
import { modalErrorRefreshCode } from '@/utils/modalUtils'
import { readRfid, resetRfid } from '@/services/qrCode/binding'
import { skuInfoByQrCodeOrEpc } from '@/services/reprint/skuCheck'
import { setReadSetting, onScanBarcodeResult, setKeyCall, onKeyMsg, onReadTagResult } from '@/services/rfEpc'
import '@/pages/AndroidDevice/PhoneLayout.less'

let errorNum = 0
let switchFlagGlobal = true

const SkuCheckPage = prpos => {
  const history = useHistory()
  const qrCodeOrEpcInputRef = useRef(null)
  // sc（思创）、Honeywell
  const [checkType] = useState(prpos.checkType || '')
  const [qrCodeOrEpcValidPass, setQrCodeOrEpcValidPass] = useState(false)
  // false为QR Code, ture为EPC
  const [switchFlag, setSwitchFlag] = useState(true)
  const [qrCodeOrEpcValue, setQrCodeOrEpcValue] = useState('')
  const [inputReadOnly, setInputReadOnly] = useState(false)
  const [skuInfo, setSkuInfo] = useState({})

  const queryHeader = {
    isRF: true
  }
  // 设置思创读取模式
  useEffect(() => {
    switchFlagGlobal = switchFlag
    if (switchFlag) {
      if (checkType === 'sc') {
        // 读取EPC
        changeKeyCall(3)
      }
    } else {
      if (checkType === 'sc') {
        // 读取QR Code
        changeKeyCall(2)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switchFlag])
  // 页面初始化
  useEffect(() => {
    qrCodeOrEpcInputRef.current.focus({ cursor: 'all' })
    if (checkType === 'Honeywell') {
      // 监听全局键盘事件
      window.addEventListener('keyup', onWindowKeyUp)
      return () => {
        // 移除全局键盘事件
        window.removeEventListener('keyup', onWindowKeyUp)
      }
    }
    // 思创手持枪
    if (checkType === 'sc') {
      // 设置功率，设置枪
      setReadSetting(1)
      // 读取二维码回调函数
      onScanBarcodeResult(data => {
        console.log('扫码结果：', data)
        setQrCodeOrEpcValue(data)
        checkValue(data)
      })
      // 读取EPC回调函数
      onReadTagResult(_data => {
        let resList = []
        if (_data && _data.data) {
          resList = _data.data.map(item => {
            return item.tagValue
          })
        }
        console.log('读取EPC结果：', _data)
        let newArr = [...resList]
        // 去重
        let resArray = Array.from(new Set(newArr))
        if (resArray.length > 1) {
          if (errorNum !== 0) return
          errorNum = 1
          let str = formatMessageNew('languageObj.qrCode.multipleEpc')
          modalErrorRefreshCode(
            {
              content: str
            },
            () => {
              errorNum = 0
            }
          )
          return
        }
        if (resArray.length === 0) {
          return
        }
        setQrCodeOrEpcValue(resArray[0])
        checkValue(resArray[0])
      })
      onKeyMsg(isStart => {
        console.log('isStart', isStart)
        if (isStart) {
          // 开始扫描
        } else {
          // 结束扫描
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // 全局键盘事件
  const onWindowKeyUp = e => {
    if (e.keyCode === 0 && e.code === 'F23') {
      if (checkType === 'Honeywell') {
        getEpcValueFun()
      }
      return
    }
  }
  // 霍尼韦尔读取epc
  const getEpcValueFun = () => {
    setQrCodeOrEpcValue('')
    readRfid()
      .then(res => {
        const value = res?.resultData?.rfid
        if (value.split(',').length > 1) {
          if (errorNum !== 0) return
          errorNum = 1
          let str = formatMessageNew('languageObj.qrCode.multipleEpc')
          modalErrorRefreshCode(
            {
              content: str
            },
            () => {
              errorNum = 0
            }
          )
          return
        }
        let val = value === 'null' ? '' : value
        setQrCodeOrEpcValue(val)
        checkValue(val)
        resetRfid()
      })
      .catch(err => {
        if (errorNum !== 0) return
        errorNum = 1
        let str = formatMessageNew('languageObj.qrCode.readEpcErr')
        modalErrorRefreshCode(
          {
            content: str
          },
          () => {
            errorNum = 0
          }
        )
      })
  }

  // 清空信息
  useEffect(() => {
    if (!qrCodeOrEpcValue) {
      setSkuInfo({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrCodeOrEpcValue])

  const onInputChange = (e, setFun) => {
    const value = e.target ? e.target.value.trim() : e
    const index = value.indexOf('/n')
    const newValue = index > -1 ? value.substring(0, index) : value
    setFun(newValue)
  }

  const onInputKeyDown = e => {
    if (e.keyCode === 13) {
      const value = e.target ? e.target.value : e
      checkValue(value)
    }
  }
  // 检查逻辑
  const checkValue = value => {
    if (!value) {
      return
    }
    skuInfoByQrCodeOrEpcFun(value)
  }

  // 查询信息
  const skuInfoByQrCodeOrEpcFun = value => {
    if (value) {
      let params = {
        code: value,
        type: switchFlagGlobal ? 1 : 2
      }
      skuInfoByQrCodeOrEpc(params, queryHeader)
        .then(res => {
          if (res && res.resultData) {
            setSkuInfo(res.resultData)
            setQrCodeOrEpcValidPass(true)
          }
          if (res.errorCode !== '200') {
            errorMessageFun(res)
          }
        })
        .catch(err => {
          errorMessageFun(err)
        })
    }
  }

  const errorMessageFun = err => {
    let strFormat = 'languageObj.reprint.errorcode_check_' + err.errorCode
    let str = formatMessageNew(strFormat)
    if (errorNum === 0) {
      errorNum = 1
      modalErrorRefreshCode(
        {
          content: str || err.errorMessage
        },
        () => {
          errorNum = 0
        }
      )
    }
  }
  // 更新 扳机事件 0 : 1 : 2 : 3 = ⽆状态 : Rfid读取模式 : 扫描条码模式 : RFIDduqu模式(扣动扳机读取，松开停止)
  const changeKeyCall = async key => {
    try {
      await setKeyCall(key, true)
    } catch (error) {
      console.error('Error overdueValidation setKeyCall:', error)
    }
  }
  const onInputFocus = () => {
    try {
      setInputReadOnly(true)
      setTimeout(() => {
        setInputReadOnly(false)
      }, 100)
    } catch (error) {}
  }

  const clearInfoFun = () => {
    setQrCodeOrEpcValue('')
    setSkuInfo({})
    setQrCodeOrEpcValidPass(false)
    setTimeout(() => {
      qrCodeOrEpcInputRef.current.focus({ cursor: 'all' })
    }, 200)
  }

  const backFirstPage = () => {
    let str = '/'
    if (localStorage.getItem('qrLogin')) {
      str = localStorage.getItem('qrLogin')
    }
    history.push(str)
  }
  const switchBtn = () => {
    setSwitchFlag(preSwitchFlag => {
      return !preSwitchFlag
    })
    setQrCodeOrEpcValue('')
    setSkuInfo({})
    setQrCodeOrEpcValidPass(false)
    setTimeout(() => {
      qrCodeOrEpcInputRef.current.focus({ cursor: 'all' })
    }, 200)
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 16
        }
      }}
    >
      <div
        style={{ maxHeight: 'calc( 100vh - 170px )', overflow: 'auto', marginLeft: -5, marginRight: -5 }}
        className="full-tag-wrapper qrcode-wrapper"
      >
        <div className="displayFlex alignCenter mt10">
          <div className="bind_label2 fontS16">
            <Input
              className="pt5 pb5"
              ref={qrCodeOrEpcInputRef}
              value={qrCodeOrEpcValue}
              allowClear
              readOnly={inputReadOnly}
              disabled={qrCodeOrEpcValidPass}
              placeholder={`${
                switchFlag
                  ? formatMessageNew('languageObj.reprint.placehilderTipEpc')
                  : formatMessageNew('languageObj.reprint.placehilderTipQrCode')
              }`}
              onFocus={() => onInputFocus()}
              onKeyDown={e => onInputKeyDown(e)}
              onChange={e => onInputChange(e, setQrCodeOrEpcValue)}
            />
          </div>
        </div>

        <div className="displayFlex alignCenter justifyContentCenter mt15 mb15">
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  borderColorDisabled: '#d9d9d9',
                  defaultBorderColor: switchFlag ? '#ffc000' : '#3671a3',
                  defaultBg: qrCodeOrEpcValidPass ? '#d9d9d9' : '#ffffff',
                  defaultActiveBorderColor: switchFlag ? '#ffc000' : '#3671a3',
                  defaultActiveBg: '#ffffff',
                  defaultActiveColor: '#000',
                  defaultHoverBorderColor: switchFlag ? '#ffc000' : '#3671a3',
                  defaultHoverBg: '#ffffff',
                  defaultHoverColor: '#000'
                }
              }
            }}
          >
            <Button
              disabled={qrCodeOrEpcValidPass}
              className="phone-btn2"
              style={{ width: 'auto' }}
              onClick={switchBtn}
            >
              {switchFlag
                ? formatMessageNew('languageObj.reprint.switchToQrCode')
                : formatMessageNew('languageObj.reprint.switchToRfidEpc')}
            </Button>
          </ConfigProvider>
        </div>

        {qrCodeOrEpcValidPass && (
          <MobileCard title={formatMessageNew('languageObj.reprint.scanResult')}>
            <MobileGrid columns={2} gap={8}>
              <MobileGrid.Item>
                <div className="fontS16">{formatMessageNew('languageObj.commonLocale.sku')}</div>
                <div className="fontS16 fw-bold">
                  {skuInfo.productCode}
                  {skuInfo.productSize ? '-' + skuInfo.productSize : ''}
                </div>
              </MobileGrid.Item>
              <MobileGrid.Item>
                <div className="fontS16">{formatMessageNew('languageObj.commonLocale.upc')}</div>
                <div className="fontS16 fw-bold">{skuInfo.upc}</div>
              </MobileGrid.Item>
              <MobileGrid.Item>
                <div className="fontS16">{formatMessageNew('languageObj.commonLocale.productName')}</div>
                <div className="fontS16 fw-bold">{skuInfo.productName}</div>
              </MobileGrid.Item>
              <MobileGrid.Item>
                <div className="fontS16">{formatMessageNew('languageObj.reprint.division')}</div>
                <div className="fontS16 fw-bold">{skuInfo.divisionName}</div>
              </MobileGrid.Item>
            </MobileGrid>
          </MobileCard>
        )}
      </div>
      <div className="btn-wrapper pb20">
        <Row justify="center">
          <Col span={12}>
            <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
              <Button style={{ height: 'auto' }} onClick={backFirstPage} type="text">
                <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
                  <RollbackOutlined style={{ fontSize: 40, color: '#1677ff' }} />
                  <div>{`${formatMessageNew('languageObj.reprint.back')}`}</div>
                </div>
              </Button>
            </div>
          </Col>

          <Col span={12}>
            <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
              <Button style={{ height: 'auto' }} disabled={!qrCodeOrEpcValue} onClick={clearInfoFun} type="text">
                <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
                  <ClearOutlined style={{ fontSize: 40, color: qrCodeOrEpcValue && '#1677ff' }} />
                  <div>{`${formatMessageNew('languageObj.commonLocale.clear')}`}</div>
                </div>
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </ConfigProvider>
  )
}
export default SkuCheckPage
